import { Box } from "@mui/material";
import React, { useState, useEffect } from "react";
import SnackbarCustom from "../../components/SnackbarCustom";
import ApiService from "../../services/ApiService";
import DropdownInput from "./Components/DropdownInput";
import Graphs from "./Graphs";
import Reports from "./Reports";

const FleetDashboard = () => {
  // Hooks

  // States
  const [loading, setLoading] = useState({
    fetch: false,
    submit: false,
  });
  const [snackbar, setSnackbar] = useState({
    isOpen: false,
    type: "", // "error" | "info" | "success" | "warning"
    message: "",
  });
  const [input, setInput] = useState({
    dateStart: null,
    dateEnd: null,
    regionId: 0,
    locationId: 0,
    incidentKategoryId: 0,
    region: null,
    location: null,
    ReportAbleTitle: "All",
    ReportAble: null,
  });
  const [dropdownData, setDropdownData] = useState({
    regional: [],
    location: [],
    reportable: [
      { name: "All", value: null },
      { name: "Yes", value: 1 },
      { name: "No", value: 0 },
    ],
  });
  const [dashboardData, setDashboardData] = useState({});

  // Return Functions
  const fetchMsData = async () => {
    try {
      const resMs = await Promise.all([
        ApiService.getMsRegional().then((res) => res.data.payload),
      ]);
      setDropdownData((prev) => ({
        ...prev,
        regional: resMs[0],
      }));
    } catch (error) {
      setSnackbar({ isOpen: true, type: "warning", message: error });
    }
  };
  const fetchMsLocation = async () => {
    try {
      const resLocation = await ApiService.getMsLokasi(input.regionId).then(
        (res) => res.data.payload
      );
      setDropdownData((prev) => ({
        ...prev,
        location: resLocation,
      }));
    } catch (error) {
      setSnackbar({ isOpen: true, type: "warning", message: error });
    }
  };
  const fetchDashboardData = async () => {
    try {
      // Omit input
      const { region, location, ReportAbleTitle, ...payload } = input;
      setLoading({ fetch: true });
      const resData = await Promise.all([
        ApiService.postIncimanLkpFleetDashboard(payload),
        // another api request here
      ]);
      if (!resData[0].data.isOk) throw resData[0].data.message;
      // console.log("data", resData[0].data.payload);
      setDashboardData(resData[0].data.payload);
    } catch (error) {
      console.log("error fetch data", error);
      setSnackbar({ isOpen: true, type: "error", message: error });
    }
    setLoading({ fetch: false });
  };

  // Void Functions

  // UseEffects
  useEffect(() => {
    fetchMsData();
  }, []);
  useEffect(() => {
    if (!input.regionId) return;
    fetchMsLocation();
  }, [input.regionId]);
  useEffect(() => {
    fetchDashboardData();
  }, [input]);

  return (
    <>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 0,
        }}
      >
        <h1>Fleet Dashboard</h1>
        <DropdownInput
          input={input}
          setInput={setInput}
          dropdownData={dropdownData}
        />
        <Reports data={dashboardData} loading={loading.fetch} />
        <Graphs data={dashboardData} loading={loading.fetch} />
      </Box>
      {/* SNACKBAR */}
      <SnackbarCustom
        duration={3000}
        type={snackbar.type || "warning"}
        open={snackbar.isOpen}
        onClose={() => setSnackbar({ ...snackbar, isOpen: false })}
        message={snackbar.message}
      />
    </>
  );
};

export default FleetDashboard;
